import type { TableProps } from '@elfsight/widget-checkout';
import { INVALID_VALUE_DASH } from '@elfsight/widget-checkout';
import { useLingui } from '@lingui/react/macro';
import { useSettings } from '@wu/widget-core';
import { useCalculations } from '../../calculations-context';
import { useCalculatorConditionalLogic } from '../../conditional-logic-context';
import { formatCalculatorValue, processCalculatorValue } from '../../utils';

export function useCalculationSummary() {
  const { t } = useLingui();
  const { thousandsSeparator, decimalSeparator } = useSettings();
  const { displayedCalculations } = useCalculatorConditionalLogic();
  const calculationsValues = useCalculations();

  const table: TableProps = {
    title: t`Calculation Summary`,
    layout: 'horizontal',
    items: []
  };

  displayedCalculations.forEach((calculation) => {
    if (calculation.visible === false) {
      return;
    }

    const processedValue = processCalculatorValue(
      calculation.format,
      calculationsValues[calculation.id]
    );
    const formattedValue = formatCalculatorValue({
      value: processedValue,
      format: calculation.format,
      thousandsSeparator,
      decimalSeparator
    });

    table.items.push({
      label: calculation.name,
      values: [{ value: formattedValue || INVALID_VALUE_DASH }]
    });
  });

  return table;
}
